import { html, nothing, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import '../icon/lib-icon';
import css from './lib-progress-bar.css';

@customElement('lib-progress-bar')
export class LibProgressBar extends LibElement {
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(css)];

  @property({ type: Number }) current = 0;
  @property({ type: Number }) min = 0;
  @property({ type: Number }) max = 100;
  @property() message = '';
  @property({ attribute: 'icon-name' }) iconName = '';
  @property({ attribute: 'icon-url' }) iconUrl = '';
  @property({ type: Boolean }) spinning = false;

  override render() {
    const range = this.max - this.min;
    const percent = `${range <= 0 ? 0 : Math.trunc(100 * (this.current - this.min) / range)}%`;
    const iconUrl = this.iconUrl || (this.iconName
      ? `_content/WAGO.SolutionsPlatform.UILibrary.Core/wago-icons-svg/${this.iconName}.svg` : '');
    const messageIcon = iconUrl ? html`<lib-icon icon-url=${iconUrl}
      ?spinning=${this.spinning || this.iconName === 'spinner'}></lib-icon>` : nothing;
    return html`<div class="progress-bar-container">
      <div class="lib-progress-row">
        <div class="lib-progress">
          <div class="lib-progress-bar" role="progressbar" style=${`width:${percent}`}
            aria-label=${this.getAttribute("aria-label") || this.message || "Progress"} aria-valuenow=${Math.min(Math.max(this.current, this.min), Math.max(this.min, this.max))} aria-valuemin=${this.min} aria-valuemax=${Math.max(this.min, this.max)}></div>
        </div>
        <div class="progress-number">${percent}</div>
      </div>
      ${this.message ? html`<div class="lib-progress-message">
        ${messageIcon}
        <span class="lib-progress-message-text">${this.message}</span>
      </div>` : nothing}
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-progress-bar': LibProgressBar; }
}
